import { Card, CardContent, Grid, TextField, Typography, Button, Select, MenuItem } from '@mui/material';
import { FaEdit } from 'react-icons/fa'
import api from '../../services/api';
import { useEffect, useState } from 'react';
import Notification from '../../components/Notification/Notification';
import { useNavigate, useParams } from 'react-router-dom';


const classes = {
    textField: {
        width: '100%',
        backgroundColor: '#fff',
    },
    root: {
        flexGrow: 1,
        margin: 20,
        marginTop: 30,
        boxShadow: 'none',
        backgroundColor: '#F5F5F5',
    },
    textTitle: {
        margin: 8,
        color: '#103168',
        fontWeight: 600,
        marginBottom: 30,
    },
    message: {
        padding: 10,
        backgroundColor: '#FFFBE8',
        color: 'rgba(0,0,0,0.8)',
        borderRadius: 7,
        width: '100%'
    },
    fullWidth: {
        width: '100%'
    },
    inputFile: {
        border: 'dashed 2px #BABABA',
        height: 55.972,
        borderRadius: 5,
        paddingTop: 5,
        textAlign: 'center'
    },
    buttonConfirm: {
        backgroundColor: '#1551B3',
        color: '#fff',
        borderRadius: 20,
        height: '45px',
        textTransform: 'capitalize',
        fontWeight: 'bold',
        fontSize: 15,
        marginTop: '17px',
        minWidth: '220px'
    },
    labelInput: {
        color: '#333333',
        fontWeight: 'bold',
        paddingLeft: 2,
        fontSize: 14
    },
    inputText: {
        backgroundColor: 'white'
    }
}


export default function StatusEdit() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [type, setType] = useState('');

    const [notify, setNotify] = useState({ isOpen: false, message: '', type: '', title: '' });

    const handleSubmit = (e) => {
        e.preventDefault();

        const data = {
            name,
            description,
            type
        };

        api.patch(`/complaint-statuses/${id}`, data)
            .then((response) => {
                setNotify({
                    isOpen: true,
                    message: 'Status editado com sucesso.',
                    type: 'success',
                    title: 'Cadastrado'
                });

                setTimeout(() => navigate('/statusregister'), 1000);
            })
            .catch((err) => {
                setNotify({
                    isOpen: true,
                    message: 'O sistema apresentou um erro ao editar',
                    type: 'error',
                    title: 'Erro'
                });
            })
    }


    useEffect(() => {
        api.get(`/complaint-statuses/${id}`)
            .then((response) => {
                const data = response.data;
                setType(data.type || '');
                setName(data.name);
                setDescription(data.description);
            })
            .catch((error) => {
                setNotify({
                    isOpen: true,
                    message: 'Os dados não puderam ser carregados com sucesso',
                    type: 'error',
                    title: 'Erro no carregamento dos dados'
                });
            })

    }, [id])


    return (
        <div>
            <form onSubmit={handleSubmit}>
                <Card style={classes.root}>
                    <CardContent>

                        <Grid container spacing={2} alignItems="center" justifyContent="center">
                            <Grid item xs={12} sm={12} lg={12}>
                                <Typography variant="h5" align="center" style={classes.textTitle}>
                                    Editar Status
                                </Typography>

                                <div style={classes.message}>
                                    Insira as informações para editar o Status selecionado.
                                </div>
                            </Grid>

                            <Grid item xs={12} sm={12} md={8} lg={8}>
                                <Typography style={classes.labelInput}>
                                    Nome
                                </Typography>

                                <TextField
                                    style={classes.inputText}
                                    fullWidth
                                    required
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={8} lg={8}>
                                <Typography style={classes.labelInput}>
                                    Descrição
                                </Typography>

                                <TextField
                                    style={classes.inputText}
                                    fullWidth
                                    required
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={8} lg={8}>
                                <Typography style={classes.labelInput}>
                                    Etapa de Status: *
                                </Typography>
                                <Select
                                    style={classes.textField}
                                    fullWidth
                                    onChange={e => setType(e.target.value)}
                                    value={type}
                                >
                                    <MenuItem value={'Abertura'}>Abertura</MenuItem>
                                    <MenuItem value={'Homologação'}>Homologação</MenuItem>
                                    <MenuItem value={'Execução'}>Execução</MenuItem>
                                    <MenuItem value={'Conclusão'}>Conclusão</MenuItem>
                                </Select>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card >

                <Grid container spacing={2} alignItems="center" justifyContent="center">
                    <Grid item>
                        <Button
                            variant="outlined"
                            type='submit'
                            startIcon={<FaEdit style={{ 'color': '#fff' }} />}
                            style={classes.buttonConfirm}
                        >
                            Editar
                        </Button>
                    </Grid>
                </Grid>
            </form >

            <Notification
                notify={notify}
                setNotify={setNotify}
            />


        </div >


    );

}